(function () {
  // The theme includes this file more than once; only the first copy runs so
  // each banner root is rendered (and its rotation drawn) exactly once.
  if (window.__tcleBannerManagerLoaded) return;
  window.__tcleBannerManagerLoaded = true;

  function arrowIcon(direction) {
    return direction === 'left'
      ? '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M9.5 3.5L5 8l4.5 4.5" /></svg>'
      : '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M6.5 3.5L11 8l-4.5 4.5" /></svg>';
  }

  function clearBanner(root) {
    root.innerHTML = '';
    root.hidden = true;
    root.removeAttribute('role');
    root.removeAttribute('aria-label');
  }

  function getMediaClasses(root, item) {
    var desktopHeight = root.dataset.imageHeight || 'adapt';
    var mobileHeight = root.dataset.mobileImageHeight || desktopHeight;
    var classes = ['tcle-banner-media', 'tcle-banner-media--' + desktopHeight, 'tcle-banner-media--mobile-' + mobileHeight];

    if (desktopHeight === 'adapt' && item && item.imageWidth && item.imageHeight) {
      classes.push('tcle-banner-media--adapt');
    }
    if (mobileHeight === 'adapt' && item && item.imageWidth && item.imageHeight) {
      classes.push('tcle-banner-media--mobile-adapt');
    }

    return classes.join(' ');
  }

  function buildSlide(root, item, index, total) {
    var slide = document.createElement('article');
    var media = document.createElement('div');
    var picture = document.createElement('picture');
    var image = document.createElement('img');
    var wrapper = item.ctaUrl ? document.createElement('a') : null;

    slide.className = 'tcle-banner-slide';
    slide.setAttribute('aria-roledescription', 'slide');
    slide.setAttribute('aria-label', 'Banner ' + (index + 1) + ' of ' + total);

    media.className = getMediaClasses(root, item);
    if (root.dataset.imageHeight === 'adapt' && item.imageWidth && item.imageHeight) {
      media.style.aspectRatio = String(item.imageWidth) + ' / ' + String(item.imageHeight);
    }

    if (item.mobileImageUrl) {
      var mobileSource = document.createElement('source');
      mobileSource.media = '(max-width: 749px)';
      mobileSource.srcset = item.mobileImageUrl;
      picture.appendChild(mobileSource);
    }

    image.src = item.imageUrl;
    image.alt = item.mobileImageAlt || item.imageAlt || '';
    image.loading = index === 0 ? 'eager' : 'lazy';
    image.decoding = 'async';

    picture.appendChild(image);

    if (wrapper) {
      wrapper.className = 'tcle-banner-link';
      var clickBase = (root.dataset.apiBase || 'https://banners.tcle.co').replace(/\/$/, '');
      wrapper.href = item.id ? clickBase + '/api/public/banners/click?b=' + encodeURIComponent(item.id) : item.ctaUrl;
      wrapper.setAttribute('aria-label', item.imageAlt || ('Open banner ' + (index + 1)));
      if (/^https?:\/\//i.test(item.ctaUrl) && item.ctaUrl.indexOf(window.location.origin) !== 0) {
        wrapper.target = '_blank';
        wrapper.rel = 'noopener noreferrer';
      }
      wrapper.appendChild(picture);
      media.appendChild(wrapper);
    } else {
      media.appendChild(picture);
    }

    slide.appendChild(media);
    return slide;
  }

  function buildTextOnlySkinny(config) {
    var slide = document.createElement('article');
    var banner = document.createElement('div');
    var content = document.createElement(config.textOnlyLinkUrl ? 'a' : 'span');

    slide.className = 'tcle-banner-slide tcle-banner-slide--text-only';
    banner.className = 'tcle-banner-text-only';
    banner.style.backgroundColor = config.textOnlyBackgroundColor || '#17414C';
    banner.style.color = config.textOnlyTextColor || '#FFFFFF';
    banner.style.minHeight = String(Math.max(32, Number(config.textOnlyHeight || 56))) + 'px';

    if (config.textOnlyBackgroundImageUrl) {
      var bg = document.createElement('div');
      bg.className = 'tcle-banner-text-only__bg';
      bg.style.backgroundImage = 'url(' + config.textOnlyBackgroundImageUrl + ')';
      bg.setAttribute('role', 'img');
      bg.setAttribute('aria-label', config.textOnlyBackgroundImageAlt || 'Banner background image');
      banner.appendChild(bg);
    }

    content.className = 'tcle-banner-text-only__content';
    content.textContent = config.textOnlyText || '';
    if (config.textOnlyFontWeight) {
      content.style.fontWeight = config.textOnlyFontWeight;
    }
    if (config.textOnlyLinkUrl) {
      content.href = config.textOnlyLinkUrl;
      if (config.textOnlyLinkFontWeight && config.textOnlyLinkFontWeight !== 'inherit') {
        content.style.fontWeight = config.textOnlyLinkFontWeight;
      }
      if (config.textOnlyLinkTextDecoration) {
        content.style.textDecoration = config.textOnlyLinkTextDecoration;
      }
      if (config.textOnlyLinkHoverColor) {
        content.addEventListener('mouseenter', function () { content.style.color = config.textOnlyLinkHoverColor; });
        content.addEventListener('mouseleave', function () { content.style.color = ''; });
      }
    }

    banner.appendChild(content);
    slide.appendChild(banner);
    return slide;
  }

  function isTextOnlyActive(config) {
    if (!config || config.displayMode !== 'text_only' || !config.textOnlyEnabled || !config.textOnlyText) return false;
    var now = Date.now();
    var startOk = !config.textOnlyStartAt || new Date(config.textOnlyStartAt).getTime() <= now;
    var endOk = !config.textOnlyEndAt || new Date(config.textOnlyEndAt).getTime() >= now;
    return startOk && endOk;
  }

  // Smart rotation (homepage hero): pinned banners lead; the rest are ordered
  // by weighted random draw (rotationWeight from the API, equal if missing).
  // No auto-advance: shoppers still move slides only with the controls.
  function orderForRotation(items, config) {
    if (!config || !config.rotationEnabled || items.length < 2) return items;
    var pinned = items.filter(function (item) { return item.pinFirst; });
    var pool = items.filter(function (item) { return !item.pinFirst; });
    var ordered = [];
    while (pool.length) {
      var total = 0;
      var weights = pool.map(function (item) {
        var w = Number(item.rotationWeight);
        w = isFinite(w) && w > 0 ? w : 1 / pool.length;
        total += w;
        return w;
      });
      var pick = Math.random() * total;
      var index = 0;
      while (index < pool.length - 1 && pick >= weights[index]) {
        pick -= weights[index];
        index += 1;
      }
      ordered.push(pool.splice(index, 1)[0]);
    }
    return pinned.concat(ordered);
  }

  // Counts a view once per banner per page load, only while the banner is
  // the visible slide and at least half the carousel is on screen.
  function createViewTracker(root, apiBase) {
    var seen = {};
    var visible = false;
    var currentId = null;
    var base = apiBase.replace(/\/$/, '');

    function send(id) {
      if (!id || seen[id]) return;
      seen[id] = true;
      var url = base + '/api/public/banners/view?b=' + encodeURIComponent(id);
      try {
        if (navigator.sendBeacon && navigator.sendBeacon(url)) return;
      } catch (e) { /* fall through */ }
      try {
        fetch(url, { method: 'POST', mode: 'no-cors', keepalive: true, credentials: 'omit' });
      } catch (e2) { /* non-critical */ }
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
          if (visible) send(currentId);
        });
      }, { threshold: [0, 0.5] });
      observer.observe(root);
    } else {
      visible = true;
    }

    return {
      show: function (id) {
        currentId = id;
        if (visible) send(id);
      }
    };
  }

  function init(root) {
    if (!root || root.dataset.tcleBannerInitialized === '1') return;
    root.dataset.tcleBannerInitialized = '1';
    clearBanner(root);

    var apiBase = root.dataset.apiBase || 'https://banners.tcle.co';
    var location = root.dataset.location || 'home_page';

    fetch(apiBase.replace(/\/$/, '') + '/api/public/banners?location=' + encodeURIComponent(location), { credentials: 'omit' })
      .then(function (response) { return response.json(); })
      .then(function (payload) {
        if (!payload || !payload.ok) {
          clearBanner(root);
          return;
        }

        var config = payload.config || {};
        if (location === 'skinny' && isTextOnlyActive(config)) {
          root.innerHTML = '';
          root.hidden = false;
          root.setAttribute('role', 'region');
          root.setAttribute('aria-label', config.ariaLabel || 'Promotional skinny banner');
          root.appendChild(buildTextOnlySkinny(config));
          return;
        }

        if (!payload.items || !payload.items.length) {
          clearBanner(root);
          return;
        }

        var items = payload.items.filter(function (item) { return !!item.imageUrl; });
        if (!items.length) {
          clearBanner(root);
          return;
        }

        var isHero = location === 'home_page';
        if (isHero) items = orderForRotation(items, config);
        var tracker = isHero && config.rotationEnabled ? createViewTracker(root, apiBase) : null;

        var current = 0;
        var track = document.createElement('div');
        track.className = 'tcle-banner-track';
        root.innerHTML = '';
        root.hidden = false;
        root.setAttribute('role', 'region');
        root.setAttribute('aria-label', config.ariaLabel || 'Promotional image banner carousel');
        root.appendChild(track);

        items.forEach(function (item, index) {
          track.appendChild(buildSlide(root, item, index, items.length));
        });

        var slides = Array.prototype.slice.call(track.children);
        function render() {
          slides.forEach(function (slide, index) {
            slide.hidden = index !== current;
            slide.setAttribute('aria-hidden', index === current ? 'false' : 'true');
          });
          if (tracker) tracker.show(items[current] && items[current].id);
        }

        function move(direction) {
          current = (current + direction + slides.length) % slides.length;
          render();
        }

        if (slides.length > 1 && config.showControls !== false) {
          var isArrowStyle = config.controlStyle === 'arrows';
          var controls = document.createElement('div');
          controls.className = 'tcle-banner-controls tcle-banner-controls--' + (isArrowStyle ? 'arrows' : 'buttons');

          var prev = document.createElement('button');
          prev.type = 'button';
          prev.className = 'tcle-banner-control tcle-banner-control--' + (isArrowStyle ? 'arrows' : 'buttons');
          prev.setAttribute('aria-label', 'Show previous banner');
          if (isArrowStyle) {
            prev.innerHTML = arrowIcon('left');
          } else {
            prev.textContent = 'Previous';
          }
          prev.addEventListener('click', function () { move(-1); });

          var next = document.createElement('button');
          next.type = 'button';
          next.className = 'tcle-banner-control tcle-banner-control--' + (isArrowStyle ? 'arrows' : 'buttons');
          next.setAttribute('aria-label', 'Show next banner');
          if (isArrowStyle) {
            next.innerHTML = arrowIcon('right');
          } else {
            next.textContent = 'Next';
          }
          next.addEventListener('click', function () { move(1); });

          controls.appendChild(prev);
          controls.appendChild(next);
          root.appendChild(controls);
        }

        render();

        if (slides.length > 1 && config.scrollMode === 'auto' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          var interval = Math.max(2, Number(config.autoRotateSeconds || 5)) * 1000;
          var timer = window.setInterval(function () { move(1); }, interval);
          if (config.pauseOnHover) {
            root.addEventListener('mouseenter', function () { clearInterval(timer); });
            root.addEventListener('mouseleave', function () {
              timer = window.setInterval(function () { move(1); }, interval);
            });
          }
        }
      })
      .catch(function () {
        clearBanner(root);
      });
  }

  function initAll(scope, force) {
    (scope || document).querySelectorAll('[data-tcle-banner-root]').forEach(function (root) {
      if (force) root.dataset.tcleBannerInitialized = '0';
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document, true);
  });
  document.addEventListener('shopify:section:select', function (event) {
    initAll(event.target || document, true);
  });
  document.addEventListener('shopify:block:select', function (event) {
    initAll(event.target || document, true);
  });
})();
